import { FormikValues, useFormikContext } from 'formik';
import { RefObject } from 'react';
import {
  FormikAddressAutofill,
  FormikAddressAutofillProps,
} from 'shared/form/FormikAddressAutofill';
import { Geocoding } from 'shared/geo/GeoHelpers';
import { applyGeocodedVenue } from 'shared/form/applyGeocodedVenue';

export interface FormikVenueAddressAutofillProps extends Omit<
  FormikAddressAutofillProps,
  'onGeocode'
> {
  name: string;
  onGeocode?: (geocoding: Geocoding) => void;
  inputRef?: RefObject<HTMLInputElement>;
}

export function FormikVenueAddressAutofill({
  name,
  onGeocode,
  inputRef,
  ...props
}: FormikVenueAddressAutofillProps) {
  const { setValues } = useFormikContext<FormikValues>();

  return (
    <FormikAddressAutofill
      {...props}
      inputRef={inputRef}
      name={`${name}.address`}
      onGeocode={(nextValue) => {
        if (nextValue) {
          void setValues((values) =>
            applyGeocodedVenue(values, name, nextValue),
          );
          onGeocode?.(nextValue);
        }
      }}
    />
  );
}
